export default "__VITE_ASSET__f80aba97__"